import type { AxiosRequestConfig, CancelToken } from "axios";
import axios from "axios";

const blogApiBaseUrl =
  import.meta.env.VITE_BLOG_API_BASE_URL ||
  (import.meta.env.DEV ? "" : "https://gateway.foxia.vn/api");

const blogClient = axios.create({
  baseURL: blogApiBaseUrl,
  headers: {
    "Content-Type": "application/json",
  },
});

export type RequestCancellation = CancelToken | AbortSignal;

export type RepoResult<T> = {
  response?: T;
  error?: unknown;
};

function getCancellationConfig(
  cancelToken?: RequestCancellation,
): Pick<AxiosRequestConfig, "cancelToken" | "signal"> {
  if (!cancelToken) {
    return {};
  }

  if ("aborted" in cancelToken) {
    return { signal: cancelToken };
  }

  return { cancelToken };
}

export async function request<T>(
  config: AxiosRequestConfig,
  cancelToken?: RequestCancellation,
): Promise<RepoResult<T>> {
  try {
    const res = await blogClient.request<T>({
      ...config,
      ...getCancellationConfig(cancelToken),
    });

    return { response: res.data };
  } catch (error) {
    return { error };
  }
}
